import React, { useState, useEffect, useRef, useContext } from 'react';
//import ModalChooseComponent from './ModalChooseComponent';

const spinList = [
    {
        name: "promo",
        img: "/img/0.webp",
        tmpl: 716921
    },
    {
        name: "common",
        img: "/img/1.webp",
        tmpl: 716922
    },
    {
        name: "uncommon",
        img: "/img/2.webp",
        tmpl: 750023
    },
    {
        name: "rare",
        img: "/img/3.webp",
        tmpl: 716924
    },
    {
        name: "epic",
        img: "/img/4.webp",
        tmpl: 716925
    },
    {
        name: "legendary",
        img: "/img/5.webp",
        tmpl: 716926
    },

    {
        name: "promo",
        img: "/img/runes/0.webp",
        tmpl: 761126
    },
    {
        name: "common",
        img: "/img/runes/1.webp",
        tmpl: 749979
    },
    {
        name: "uncommon",
        img: "/img/runes/2.webp",
        tmpl: 749981
    },
    {
        name: "rare",
        img: "/img/runes/3.webp",
        tmpl: 749982
    },
    {
        name: "epic",
        img: "/img/runes/4.webp",
        tmpl: 749983
    },
    {
        name: "legendary",
        img: "/img/runes/5.webp",
        tmpl: 749984
    }
]

const chooseByName = (name) => {

    let obj;
    if (name == "promo" || name === 0) {
        obj = {
            rarity: 0,
            asset_id: 1000000000000000,
            //user	
            cons: 0.2,
            mult: 1.1,
            countdown: 3600 * 3,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            rarity: 0,
            //timer	
            //in_slot	
            vip: 0
            //lastacttime	
            //boofsec	
            //inlottery
        }
    } else if (name == "common" || name === 1) {
        obj = {
            rarity: 1,
            asset_id: 1000000000000000,
            cons: 1,
            mult: 1.1,
            countdown: 3600 * 3,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0
        }
    } else if (name == "uncommon" || name === 2) {
        obj = {
            rarity: 2,
            asset_id: 1000000000000000,
            cons: 2,
            mult: 1.1,
            countdown: 3600 * 3,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0
        }
    } else if (name == "rare" || name === 3) {
        obj = {
            rarity: 3,
            asset_id: 1000000000000000,
            cons: 8,
            mult: 1.1,
            countdown: 3600 * 6,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0
        }
    } else if (name == "epic" || name === 4) {
        obj = {
            rarity: 4,
            asset_id: 1000000000000000,
            cons: 16,
            mult: 1.1,
            countdown: 3600 * 6,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0
        }
    } else if (name == "legendary" || name === 5) {
        obj = {
            rarity: 5,
            asset_id: 1000000000000000,
            cons: 64,
            mult: 1.1,
            countdown: 3600 * 12,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0
        }
    }

    return obj;
}

function MarketComponent({ prices, pricesHist }) {
    const [view, setView] = useState(() => {
        const views = localStorage.getItem('view');
        return views ? JSON.parse(views) : false;
    });

    const [listWithPrice, setListWithPrice] = useState([])

    useEffect(() => {

        if (prices && prices.length && pricesHist && pricesHist.length && !listWithPrice.length) {
            const updatedSpinList = spinList.map(spinItem => {
                // Находим соответствующий элемент в results
                const resultItem = prices.find(result => result.template_id == spinItem.tmpl);
                const resultItemHist = pricesHist.find(result => result.template_id == spinItem.tmpl);
                // Если в resultItem есть данные и у них есть price, извлекаем эту цену
                const pr = resultItem ? resultItem.price : null;
                const prHist = resultItemHist ? resultItemHist.price : null;
                // Возвращаем новый объект, добавляя информацию о цене
                return {
                    ...spinItem,
                    price: pr,
                    priceHist: prHist
                };
            });

            console.log("updatedSpinList", updatedSpinList)
            setListWithPrice(updatedSpinList);
        }
    }, [prices, pricesHist]);

    return (
        <>

            <div className={`all-spin ${view ? "short" : "full"}`}>

                {listWithPrice && listWithPrice.length ?
                    listWithPrice.map((item, index) => {
                        return (
                            <div className="one-spin" key={index}>
                                <div className='remove-spiner'>
                                    remove
                                </div>
                                <div className='change-spiner'>
                                    change
                                </div>

                                <div className="one-spin-img">
                                    <span>
                                        <img src={item.img} alt="" />
                                    </span>
                                </div>

                                <div className="one-spin-runes">
                                    Price on market: {(item.price / 100000000).toFixed(4)}
                                </div>

                                <div className="one-spin-runes">
                                    Last Price History: {(item.priceHist / 100000000).toFixed(4)}
                                </div>

                                <div className="one-spin-speed">

                                </div>
                                <div className="one-spin-spins">

                                </div>


                            </div>
                        )
                    })

                    : null}


                {/* {modalChooseOpen ? <ModalChooseComponent openModal={openModal} typeModal={typeModal} addNew={addNew} /> : null} */}
            </div>
        </>
    );
}

export default MarketComponent;
